<template>
  <div id="levelstage" v-show="showcounter" >
    <backgroundFast></backgroundFast>
    <div class='counter' aria-hidden="true">{{counter}}</div>
    <h1 id="message" role="status" aria-live="polite">Pronti</h1>
  </div>
</template>

<script>
import backgroundFast from './background-fast';
export default {
  mounted() {

},
  updated() {

},
  components: {
    backgroundFast
  },
  data() {
    return {
      counter:3,
      showcounter:false,
    }
  },
  watch:{
    start(val) {
      if (val == true) {
        this.setCounter();
      }
    }
  },
  props:["start"],
  methods: {
    setCounter() {
      
        this.showcounter = true;
        let b = setInterval(a=>{
            this.counter--;
          if (this.counter ==0) {
            clearInterval(b)
            this.showcounter=false;
            this.showstate = false;
            this.$emit('completed');

          }
        },1000)
    }
  }
}
</script>

<style scoped>
h1 {
  font-family: 'Press Start 2P', cursive;
  font-size:32px;
}
#levelstage {
    font-family: 'Press Start 2P', cursive;
}
.counter {
    font-size:22px;
    animation: counterAnim 1s infinite;
    position:absolute;
    top:0;
    width:100px;
    text-align:center;
    left:calc(50% - 50px);
    display:block;
    color:red;
    font-family: 'Press Start 2P', cursive;
  }

  @keyframes counterAnim {
    0% {font-size:16px}
    100% {font-size:80px; opacity:.4}
  }

  #message {
    text-align:center;
    margin-top:108px;
    color:white;
  }
</style>